import { buildConfig } from "@/config/buildConfig.autogenerated";
import { CordovaAudioPlayerState } from "@/lib/audio-player/CordovaAudioPlayerState";
import { WebAudioPlayerState } from "@/lib/audio-player/WebAudioPlayerState";

export function buildPlayerState() {
  return buildConfig.platform === "web"
    ? new WebAudioPlayerState()
    : new CordovaAudioPlayerState();
}
